import type { DestroyOptions } from 'pixi.js';
import { Container, Sprite, Text } from 'pixi.js';
import { Signal } from 'typed-signals';
import { TileView, TILE_WIDTH, TILE_Z_OFFSET } from '../../game/boardMVC/views/board/TileView';
import type { TileStackModel } from '../../game/boardMVC/models/board/TileStackModel';

export class EditorTrayStackView extends Container {
  public readonly background = Sprite.from('tile_empty').props({
    parent: this,
    anchor: 0.5,
    x: TILE_WIDTH / 2,
  });

  public readonly tiles = new Container<TileView>().props({
    parent: this,
    x: TILE_WIDTH / 2,
  });

  private readonly labelText: Text = new Text({
    text: '',
    style: {
      fontSize: 30,
      fill: {
        color: 'white',
      },
      stroke: {
        color: 'black',
        width: 2,
      },
    },
  }).props({
    parent: this,
    x: TILE_WIDTH / 2,
    y: 34,
    anchor: 0.5,
  });

  public readonly onStackPointerDown = new Signal<(stackView: EditorTrayStackView) => void>();

  constructor(private readonly model: TileStackModel) {
    super();

    model.getTiles().forEach((tileModel) => {
      this.addTileView(new TileView(tileModel));
    });

    this.interactiveChildren = true;
    this.interactive = true;
    this.onpointertap = (): void => {
      this.onStackPointerDown.emit(this);
    };
  }

  public getTileView(tileId: string): TileView | null {
    return this.tiles.children.find((tileView) => tileView.model?.id === tileId) ?? null;
  }

  public addTileView(tileView: TileView | TileView[]): this {
    if (Array.isArray(tileView)) {
      tileView.forEach((view) => this.addTileView(view));
      return this;
    }

    tileView.position.set(0, this.getVisibleZOffset());

    this.tiles.addChild(tileView);
    return this;
  }

  public removeTile(tileView: TileView): void {
    this.tiles.removeChild(tileView);
  }

  public getVisibleZOffset(): number {
    return -this.tiles.children.length * TILE_Z_OFFSET;
  }

  public setLabelText(text: string): void {
    this.labelText.text = text;
  }

  public getModel(): TileStackModel {
    return this.model;
  }

  public destroy(options?: DestroyOptions): void {
    this.onStackPointerDown.disconnectAll();
    super.destroy(options);
  }
}
